import {
  Box,
  Button,
  Checkbox,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Select,
  Text,
  useToast,
} from "@chakra-ui/react";
import PropTypes from "prop-types";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import ModelFooterButtons from "./modelFooterButtons";
import ModelsTriggerButton from "./modelsTriggerButton";

import { Field, Formik } from "formik";
import { useSelector } from "react-redux";
import * as Yup from "yup";
import { getCustomerAPI } from "../redux/helpers/customerAPI";
import {
  addDeviceAPI,
  assignDeviceAPI,
  getDeviceAPI,
} from "../redux/helpers/deviceAPI";
import Loader from "./loader";
import SuccessMessageModal from "./successMessageModal";

const AddDeviceModal = ({
  isOpen,
  onClose,
  setIsModalOpen,
  device,
  handleDevTypeOpen,
  handleDevModelOpen,
  handleDevfirmwareOpen,
  isModify,
  reloadDataForAccount,
}) => {
  const initialRef = useRef(null);
  const finalRef = useRef(null);
  const [device_type, setDeviceType] = useState(null);
  const [firmware_id, setFirmwareID] = useState(null);
  const [tested_by, setTestedBy] = useState(null);
  const [device_model, setModelSelected] = useState(null);
  const [customer_id, setAssignCustomer] = useState([]);
  const [producedDate, setProducedDate] = useState(null);
  const [currentModels, setCurrentModels] = useState([]);
  const [provisioningStatus, setProvisioningStatus] = useState(device?.status);
  const [generateSerialNo, setGenerateSerialNo] = useState("");
  const [serialNo, setSerialNo] = useState("");
  const [loading, setLoading] = useState(true);
  const [successMessage, setSuccessMessage] = useState("");
  const [isSuccessModalOpen, setisSuccessModalOpen] = useState(false);
  const types = useSelector((state) => state?.controllers?.types);
  const models = useSelector((state) => state?.controllers?.models);
  const customerOrgList = useSelector((state) => state.customer.organizations);
  const [isAssignToCustomer, setIsAssignToCustomer] = useState(false);
  const dispatch = useDispatch();
  const toast = useToast();
  const teamMemberData = useSelector(
    (state) => state?.teamMember?.teamMemberData
  );
  const firmwareData = useSelector((state) => state?.firmware?.firmwareData);
  const [firmwareSelected, setFirmwareSelected] = useState([]);

  console.log("firmwareData", firmwareSelected, device_model);

  useEffect(() => {
    Promise.all([dispatch(getCustomerAPI())])
      .then(() => {
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        console.error("Error fetching data:", error);
      });
  }, []);

  const onTypeSelected = (typeID) => {
    console.log("kjnkjsnvjdbjbd");
    setDeviceType(typeID);
    let currentModelsSelected = models?.filter(
      (model) => model?.device_type?.id == typeID
    );
    setCurrentModels(currentModelsSelected);

    let currentFirmwareSelected = firmwareData?.filter(
      (firmware) => firmware?.device_model?.id == currentModelsSelected[0]?.id
    );

    console.log("nscnsdvnsdv", currentFirmwareSelected);
    setFirmwareSelected(currentFirmwareSelected);
  };

  const onFirmwareSelected = (firmwareID) => {
    setFirmwareID(firmwareID);
  };

  const onTestedBySelected = (testedBy) => {
    setTestedBy(testedBy);
  };

  const onModelSelected = (model) => {
    setModelSelected(model);
    let currentFirmwareSelected = firmwareData?.filter(
      (firmware) => firmware?.device_model?.id == model
    );

    console.log("nscnsdvnsdv", currentFirmwareSelected);
    setFirmwareSelected(currentFirmwareSelected);
  };

  const onCustomerSelected = (customer) => {
    setAssignCustomer(customer);
  };

  const assignDeviceToCustomer = () => {
    setLoading(true);
    try {
      const deviceReq = dispatch(getDeviceAPI());
      deviceReq.then((result) => {
        const device = result.payload.data;
        const device_data_id = device?.filter((val) => {
          return val?.serial_number == serialNo;
        });
        const payload = {
          device_id: device_data_id[0]?.id,
          assigned_to_id: customer_id,
        };
        dispatch(assignDeviceAPI(payload));
        setLoading(false);
      });
    } catch (err) {
      setLoading(false);
      console.log(err);
    }
  };

  // Reload Data for account

  /**
   * 1. reload devices types
   * 2. reload device models
   * 3. reload devices
   */

  // const reloadDataForAccount = () => {
  //   dispatch(getTypesAPI(token));
  //   dispatch(getDeviceAPI(token));
  //   dispatch(getModelsAPI(token));
  // }

  // End Reload Data for account
  const nameRegex = /^[a-zA-Z0-9\s]+$/;
  const formValidationSchema = Yup.object().shape({
    device_name: Yup.string()
      .max(45, "Model name must be at most 45 characters.")
      .matches(
        nameRegex,
        "Device name can only contain Letters, Numbers & Spaces"
      )
      .required("Device name is required"),
    device_type: Yup.string().required("Device type is required"),
    device_model: Yup.string().required("Device model is required"),
    serial_no: Yup.string().required("Serial number is required"),
    provisioning_status: Yup.boolean(),
    firmware_id: Yup.string().required("Firmware is required"),
    date_produced: Yup.date().required("Date produced is required"),
    date_tested: Yup.date().required("Date tested is required"),
    tested_by_id: Yup.string().required("Tested by is required"),
  });

  const styles = {
    formItem: {
      mt: 4,
    },
    input: {
      size: "sm",
      borderRadius: 6,
    },
  };

  return (
    <>
      <Loader loading={loading} />
      <ModelsTriggerButton setIsModalOpen={setIsModalOpen} type="Unit" />
      <Modal
        blockScrollOnMount={false}
        initialFocusRef={initialRef}
        finalFocusRef={finalRef}
        isOpen={isOpen}
        onClose={onClose}
        scrollBehavior={"inside"}
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader> {isModify ? "Modify" : "Add "} Unit</ModalHeader>
          <ModalCloseButton />
          <ModalBody pb={2}>
            <Formik
              initialValues={{
                device_name: "",
                device_type: "",
                device_model: "",
                serial_no: "",
                provisioning_status: "",
                firmware_id: "",
                date_produced: "",
                date_tested: "",
                tested_by_id: "",
              }}
              validationSchema={formValidationSchema}
              onSubmit={(values) => {
                setLoading(true);
                try {
                  const data = {
                    name: values?.device_name,
                    type_id: device_type,
                    model_id: device_model,
                    provisioningStatus: values?.provisioning_status,
                    serial_number: values?.serial_no,
                    firmware_id: firmware_id,
                    date_produced: Math.floor(
                      new Date(values?.date_produced).getTime() / 1000
                    ),
                    date_tested: Math.floor(
                      new Date(values?.date_tested).getTime() / 1000
                    ),
                    tested_by_id: tested_by,
                  };

                  console.log("datatatatatat", data);

                  const addDeviceReq = dispatch(addDeviceAPI(data));
                  addDeviceReq.then((data) => {
                    if (data?.payload?.success) {
                      setLoading(false);
                      if (isAssignToCustomer) {
                        assignDeviceToCustomer();
                      }
                      setSuccessMessage("added");
                      setIsAssignToCustomer(false);
                      setGenerateSerialNo(null);
                      onClose();
                      setisSuccessModalOpen(true);
                    } else {
                      setLoading(false);
                      toast({
                        title: "Error while adding Controller",
                        description: data?.payload?.message,
                        status: "error",
                        duration: 6000,
                        isClosable: true,
                      });
                    }
                  });
                } catch (err) {
                  setLoading(false);
                  console.log("errror");
                }
              }}
            >
              {({
                handleSubmit,
                handleChange,
                errors,
                touched,
                setFieldValue,
              }) => (
                <form onSubmit={handleSubmit}>
                  <FormControl
                    {...styles.formItem}
                    isInvalid={errors.serial_no && touched.serial_no}
                  >
                    <FormLabel> Device Serial No </FormLabel>
                    <Checkbox
                      name="generateSerialNo"
                      colorScheme="green"
                      isChecked={generateSerialNo}
                      onChange={(e) => {
                        let slNo = Date.now();
                        setFieldValue("serial_no", slNo);
                        setSerialNo(slNo);
                        setGenerateSerialNo(e.target.checked);
                      }}
                    >
                      Auto Generate Unique Serial No
                    </Checkbox>
                    <Field
                      as={Input}
                      {...styles.input}
                      style={{ marginTop: 10 }}
                      ref={initialRef}
                      placeholder="Serial No"
                      disabled={generateSerialNo}
                      id="serial_no"
                      name="serial_no"
                    />
                    <FormErrorMessage>{errors.serial_no}</FormErrorMessage>
                  </FormControl>

                  <FormControl
                    {...styles.formItem}
                    isInvalid={errors.device_name && touched.device_name}
                  >
                    <FormLabel>Name</FormLabel>
                    <Field
                      as={Input}
                      {...styles.input}
                      placeholder="Device name"
                      name="device_name"
                      id="device_name"
                    />
                    <FormErrorMessage>{errors.device_name}</FormErrorMessage>
                  </FormControl>

                  <FormControl
                    {...styles.formItem}
                    isInvalid={errors.device_type && touched.device_type}
                  >
                    <FormLabel>
                      <Box
                        display={"flex"}
                        flexDirection={"row"}
                        justifyContent={"space-between"}
                        alignItems={"center"}
                      >
                        Product
                        <Button
                          size={"xs"}
                          type="primary"
                          onClick={() => handleDevTypeOpen()}
                        >
                          <Text
                            textAlign={"end"}
                            fontSize={12}
                            color={"#0071FF"}
                          >
                            New Product +
                          </Text>
                        </Button>
                      </Box>
                    </FormLabel>
                    <Select
                      {...styles.input}
                      id="device_type"
                      name="device_type"
                      placeholder="Select Product"
                      onChange={(event) => {
                        setFieldValue("device_type", event.target.value);
                        onTypeSelected(event.target.value);
                      }}
                    >
                      {types?.map((val, index) => {
                        return (
                          <option key={index} value={val.id}>
                            {val.name}
                          </option>
                        );
                      })}
                    </Select>
                    <FormErrorMessage>{errors.device_type}</FormErrorMessage>
                  </FormControl>

                  <FormControl
                    {...styles.formItem}
                    isInvalid={errors.device_model && touched.device_model}
                  >
                    <FormLabel>
                      <Box
                        display={"flex"}
                        flexDirection={"row"}
                        justifyContent={"space-between"}
                        alignItems={"center"}
                      >
                        Model
                        <Button
                          size={"xs"}
                          type="primary"
                          onClick={() => {
                            handleDevModelOpen();
                          }}
                        >
                          <Text
                            textAlign={"end"}
                            fontSize={12}
                            color={"#0071FF"}
                          >
                            New Model +
                          </Text>
                        </Button>
                      </Box>
                    </FormLabel>
                    <Select
                      {...styles.input}
                      id="device_model"
                      name="device_model"
                      placeholder="Select Product"
                      onChange={(event) => {
                        setFieldValue("device_model", event.target.value);
                        onModelSelected(event.target.value);
                      }}
                    >
                      {currentModels?.map((val, index) => {
                        return (
                          <option key={index} value={val.id}>
                            {val.name}
                          </option>
                        );
                      })}
                    </Select>
                    <FormErrorMessage>{errors.device_model}</FormErrorMessage>
                  </FormControl>

                  <FormControl
                    {...styles.formItem}
                    isInvalid={errors.firmware_id && touched.firmware_id}
                  >
                    <FormLabel>
                      <Box
                        display={"flex"}
                        flexDirection={"row"}
                        justifyContent={"space-between"}
                        alignItems={"center"}
                      >
                        Firmware
                        <Button
                          size={"xs"}
                          type="primary"
                          onClick={() => {
                            handleDevfirmwareOpen();
                          }}
                        >
                          <Text
                            textAlign={"end"}
                            fontSize={12}
                            color={"#0071FF"}
                          >
                            New Firmware +
                          </Text>
                        </Button>
                      </Box>
                    </FormLabel>
                    <Select
                      {...styles.input}
                      placeholder="Select Firmware"
                      id="firmware_id"
                      name="firmware_id"
                      onChange={(event) => {
                        setFieldValue("firmware_id", event.target.value);
                        onFirmwareSelected(event.target.value);
                      }}
                    >
                      {firmwareSelected?.map((val, index) => {
                        return (
                          <option key={index} value={val.id}>
                            {val.name}
                          </option>
                        );
                      })}
                    </Select>
                    <FormErrorMessage>{errors.firmware_id}</FormErrorMessage>
                  </FormControl>

                  <FormControl
                    {...styles.formItem}
                    isInvalid={errors.date_produced && touched.date_produced}
                  >
                    <FormLabel>
                      <Box
                        display={"flex"}
                        flexDirection={"row"}
                        justifyContent={"space-between"}
                        alignItems={"center"}
                      >
                        Date Produced
                      </Box>
                    </FormLabel>
                    <Field
                      {...styles.input}
                      as={Input}
                      placeholder="Select Date"
                      id="date_produced"
                      name="date_produced"
                      max={new Date().toISOString().split("T")[0]}
                      type="date"
                      onChange={(event) => {
                        setProducedDate(event.target.value);
                        setFieldValue("date_produced", event.target.value);
                      }}
                    />
                    <FormErrorMessage>{errors.date_produced}</FormErrorMessage>
                  </FormControl>

                  <FormControl
                    {...styles.formItem}
                    isInvalid={errors.date_tested && touched.date_tested}
                  >
                    <FormLabel>
                      <Box
                        display={"flex"}
                        flexDirection={"row"}
                        justifyContent={"space-between"}
                        alignItems={"center"}
                      >
                        Date Tested
                      </Box>
                    </FormLabel>
                    <Field
                      {...styles.input}
                      as={Input}
                      placeholder="Select Date"
                      min={new Date(producedDate).toISOString().split("T")[0]}
                      max={new Date().toISOString().split("T")[0]}
                      id="date_tested"
                      name="date_tested"
                      type="date"
                    />
                    <FormErrorMessage>{errors.date_tested}</FormErrorMessage>
                  </FormControl>

                  <FormControl
                    {...styles.formItem}
                    isInvalid={errors.tested_by_id && touched.tested_by_id}
                  >
                    <FormLabel>
                      <Box
                        display={"flex"}
                        flexDirection={"row"}
                        justifyContent={"space-between"}
                        alignItems={"center"}
                      >
                        Tested By
                      </Box>
                    </FormLabel>
                    <Select
                      {...styles.input}
                      placeholder="Select Tested By"
                      id="tested_by_id"
                      name="tested_by_id"
                      onChange={(event) => {
                        setFieldValue("tested_by_id", event.target.value);
                        onTestedBySelected(event.target.value);
                      }}
                    >
                      {teamMemberData?.map((val, index) => {
                        return (
                          <option key={index} value={val.id}>
                            {val.first_name} {val.last_name}
                          </option>
                        );
                      })}
                    </Select>
                    <FormErrorMessage>{errors.tested_by_id}</FormErrorMessage>
                  </FormControl>

                  <FormControl
                    {...styles.formItem}
                    isInvalid={
                      errors.assign_Customer && touched.assign_Customer
                    }
                  >
                    <Checkbox
                      name="assign_Customer"
                      colorScheme="green"
                      isChecked={isAssignToCustomer}
                      onChange={(e) => setIsAssignToCustomer(e.target.checked)}
                    >
                      Assign to Customers?
                    </Checkbox>
                    {isAssignToCustomer && (
                      <Select
                        marginTop={"10px"}
                        {...styles.input}
                        placeholder="Select Customer"
                        id="assign_Customer"
                        name="assign_Customer"
                        onChange={(event) =>
                          onCustomerSelected(event.target.value)
                        }
                      >
                        {customerOrgList?.map((val, index) => {
                          return (
                            <option key={index} value={val.id}>
                              {val.name}
                            </option>
                          );
                        })}
                      </Select>
                    )}
                    <FormErrorMessage>
                      {errors.assign_Customer}
                    </FormErrorMessage>
                  </FormControl>
                  <FormControl
                    {...styles.formItem}
                    isInvalid={
                      errors.provisioning_status && touched.provisioning_status
                    }
                  >
                    <FormLabel>Provision Status </FormLabel>
                    <Checkbox
                      name="provisioning_status"
                      id="provisioning_status"
                      colorScheme="green"
                      isChecked={provisioningStatus}
                      onChange={(e) => setProvisioningStatus(e.target.checked)}
                    >
                      Provisioned
                    </Checkbox>
                    <FormErrorMessage>
                      {errors.provisioning_status}
                    </FormErrorMessage>
                  </FormControl>
                  <ModelFooterButtons onClose={onClose} onSave={handleSubmit} />
                </form>
              )}
            </Formik>
          </ModalBody>
        </ModalContent>
      </Modal>
      {isSuccessModalOpen && (
        <SuccessMessageModal
          isOpen={isSuccessModalOpen}
          message={`Device ${successMessage} successfully!`}
          onClose={() => {
            setisSuccessModalOpen(false);
            reloadDataForAccount();
          }}
        />
      )}
    </>
  );
};

AddDeviceModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  setIsModalOpen: PropTypes.func.isRequired,
  device: PropTypes.object.isRequired,
  handleDevTypeOpen: PropTypes.func.isRequired,
  handleDevModelOpen: PropTypes.func.isRequired,
  handleDevfirmwareOpen: PropTypes.func.isRequired,
  isModify: PropTypes.bool.isRequired,
  reloadDataForAccount: PropTypes.func,
};
export default AddDeviceModal;
